module.exports = __webpack_public_path__ + "static/img/guide-19.6d1970d2.png";